import React, { useState } from 'react';
import '../assets/style.css';
import 'tailwindcss/tailwind.css';
import FullScreenImage from './FullScreenImage';

// Import your images
import mcrBlackParadeFinal from '../assets/images/BLACK PARADE/black parade tour 2025.webp';

import mcrprocessSketch from '../assets/images/BLACK PARADE/mcrbp-process-sketch.webp';
import mcrprocess1 from '../assets/images/BLACK PARADE/mcrbp-process-1.webp';
import mcrprocess2 from '../assets/images/BLACK PARADE/mcrbp-process-2.webp';
import mcrprocess3 from '../assets/images/BLACK PARADE/mcrbp-process-3.webp';
import mcrprocess4 from '../assets/images/BLACK PARADE/mcrbp-process-4.webp';
import mcrprocess5 from '../assets/images/BLACK PARADE/mcrbp-process-5.webp';
import mcrprocess6 from '../assets/images/BLACK PARADE/mcrbp-process-6.webp';
import mcrprocess65 from '../assets/images/BLACK PARADE/mcrbp-process-6.5.webp';
import mcrprocess7 from '../assets/images/BLACK PARADE/mcrbp-process-7.webp';
import mcrprocess8 from '../assets/images/BLACK PARADE/mcr-final-tablet-pic.webp';

import mcrConcertSelfie from '../assets/images/BLACK PARADE/mcrConcertSelfie.webp';
import mcrStickers from '../assets/images/BLACK PARADE/mcrStickers.webp';
import mcrStickerMockup from '../assets/images/BLACK PARADE/mcrStickerMockup.webp';

import mcrScreenProcess1 from '../assets/images/BLACK PARADE/mcrScreenProcess1.webp';
import mcrScreenProcess2 from '../assets/images/BLACK PARADE/mcrScreenProcess2.webp';
import mcrScreenProcess3 from '../assets/images/BLACK PARADE/mcrScreenProcess3.webp';
import mcrScreenprintFinal from '../assets/images/BLACK PARADE/mcrScreenprintFinal.webp';
import mcrScreenprintFinal2 from '../assets/images/BLACK PARADE/mcrScreenprintFinal2.webp';




const MCRBlackParade = () => {
  const [fullScreenImage, setFullScreenImage] = useState(null);

  const handleImageClick = (src) => {
    setFullScreenImage(src);
  };

  const handleCloseFullScreen = () => {
    setFullScreenImage(null);
  };

  // Store images in an array
  const images = [mcrBlackParadeFinal, mcrprocessSketch, mcrprocess1, 
    mcrprocess2, mcrprocess3, mcrprocess4, mcrprocess5, mcrprocess6, mcrprocess65, 
    mcrprocess7, mcrprocess8, mcrConcertSelfie, mcrStickers, mcrStickerMockup,
  mcrScreenProcess1, mcrScreenProcess2, mcrScreenProcess3, mcrScreenprintFinal, mcrScreenprintFinal2 ];

  const handlePrevImage = () => {
    if (!fullScreenImage) return;
    const currentIndex = images.indexOf(fullScreenImage);
    if (currentIndex === -1) return;
    const prevIndex = (currentIndex - 1 + images.length) % images.length;
    setFullScreenImage(images[prevIndex]);
  };

  const handleNextImage = () => {
    if (!fullScreenImage) return;
    const currentIndex = images.indexOf(fullScreenImage);
    if (currentIndex === -1) return;
    const nextIndex = (currentIndex + 1) % images.length;
    setFullScreenImage(images[nextIndex]);
  };

  return (
    <div>
      {/* Navigation header info bar */}
   

      <div className="columns-1 p-3 md:p-10 m-5 md:m-10">
        <h1 className=" text-center" style={{ fontFamily: 'Bebas Neue', color: '#6ac9cb', fontSize: '48px' }}>
          'Long Live' the Black Parade
        </h1>
        <p className="text-left text-gray-600 mx-2 sm:mx-4 md:mx-14 lg:mx-20 xl:mx-56 2xl:mx-72 mb-6 leading-relaxed">
          For this project, I wanted to create an illustration to wear for a tour date. I wanted to make something
           that didn't really exist much anywhere else, and I really enjoy drawing skeletons and creating 
           concept art, so this is the direction I went with. I like the tarot card look, and pulled together 
           something that's fun, engaging, and unique.

         
      <br></br>
         <br></br>
          I started by sketching and brainstorming different elements to include, and 
          settled on a color palette that was inspired by muted tones of black, dark blue, 
          old gold, and a light lavender. From there, I drew out different elements in 
          Photoshop, and created the composition. 
          
         I wanted an illustration that was emo, energetic, professional and unique to my 
         style that engages the audience. The skeleton flying the Black Parade flag, moons, 
         and bats are all symbolic to this era of music. 
        </p>

        {/* Paramore Image Display */}
        <img
  src={mcrBlackParadeFinal}
  className="mx-auto w-full sm:w-[500px] md:w-[700px] lg:w-[500px] h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrBlackParadeFinal, 0)}
  alt="black parade art"
/>

        <h2 className="text-2xl sm:text-3xl md:text-2xl sm:ml-8 md:ml-12 lg:ml-24 xl:ml-32 2xl:ml-72 font-bold text-gray-800 mb-4 mt-8 text-left">
      Illustration process </h2>

      

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 place-items-center px-4 sm:px-8 md:px-12 lg:px-24 xl:px-32 2xl:px-72">
     
  <img
    src={mcrprocessSketch}
    className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
    onClick={() => handleImageClick(mcrprocessSketch, 0)}
    alt="black parade art"
  />
  <img
    src={mcrprocess1}
    className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
    onClick={() => handleImageClick(mcrprocess1, 0)}
    alt="black parade art"
  />


  <img
    src={mcrprocess2}
    className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
    onClick={() => handleImageClick(mcrprocess2, 0)}
    alt="black parade art"
  />
</div>


<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 place-items-center px-4 sm:px-8 md:px-12 lg:px-24 xl:px-32 2xl:px-72 mt-7">

<img
  src={mcrprocess3}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrprocess3, 0)}
  alt="black parade art"
/>
<img
  src={mcrprocess4}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrprocess4, 0)}
  alt="black parade art"
/>


<img
  src={mcrprocess5}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrprocess5, 0)}
  alt="black parade art"
/>
</div>

<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 place-items-center px-4 sm:px-8 md:px-12 lg:px-24 xl:px-32 2xl:px-72 mt-7">

<img
  src={mcrprocess6}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrprocess6, 0)}
  alt="black parade art"
/>
<img
  src={mcrprocess65}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrprocess65, 0)}
  alt="black parade art"
/>


<img
  src={mcrprocess7}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrprocess7, 0)}
  alt="black parade art"
/>


</div>






        <div className="flex flex-col items-center md:flex-row md:justify-center md:gap-4"> 
        

          {/* Second Column (paramoreWork and paramoreWork2 side by side) */}
{/* Second Column (paramoreWork, paramoreWork2, paramoreShirtPrint, paramoreShirt) */}
<div className="flex flex-col sm:flex-row justify-center gap-4 mb-8 md:w-1/2">
 


</div>

         
        </div>

        <img
  src={mcrprocess8}
  className="mx-auto w-full sm:w-[500px] md:w-[700px] lg:w-[500px] h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrBlackParadeFinal, 0)}
  alt="black parade art"
/>

<p className="text-left text-gray-600 mx-2 sm:mx-4 md:mx-16 lg:mx-24 xl:mx-56 2xl:mx-72 mb-6 mt-2 leading-relaxed">
        Here's some of my work process. It includes design research such as sketching, the 
        final color palette, different iterations and things that I struggled with such as the
        skeleton's hand motion, close-ups of different collage pieces as I drew, as well as 
        the final product. </p>
      

<h2 className="text-2xl sm:text-3xl md:text-2xl sm:ml-8 md:ml-12 lg:ml-24 xl:ml-32 2xl:ml-72 font-bold text-gray-800 mb-4 mt-8 text-left">
       Spotted: Out in the wild </h2>
       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 place-items-center px-4 sm:px-8 md:px-12 lg:px-24 xl:px-32 2xl:px-72 mt-7">

<img
  src={mcrConcertSelfie}
  className="max-w-[400px] w-full h-[300px] object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrConcertSelfie, 0)}
  alt="my chemical romance concert selfie"
/>

<img
  src={mcrStickers}
  className="max-w-[400px] w-full h-[300px] object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrStickers, 0)}
  alt="black parade stickers"
/>

<img
  src={mcrStickerMockup}
  className="max-w-[400px] w-full h-[300px] object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrStickerMockup, 0)}
  alt="mcr black parade sticker mockup on bag"
/>

</div>



<p className="mb-3 text-left text-gray-600 mb-10 mt-0 mx-2 sm:mx-4 md:mx-8 lg:mx-28 xl:mx-56 2xl:mx-6 2xl:ml-72 mt-2">

These were the final printed pieces that were worn by me at the show, and stickers that I had printed and
handed out to other fans.
</p>

<h2 className="text-2xl sm:text-3xl md:text-2xl sm:ml-8 md:ml-12 lg:ml-24 xl:ml-32 2xl:ml-72 font-bold text-gray-800 mb-4 mt-8 text-left">
       CMYK Screenprint </h2>


<div className="flex flex-col sm:flex-row sm:justify-start gap-3 mx-2 sm:mx-4 md:mx-8 lg:mx-32 xl:mx-56 2xl:mx-60 mb-2 mt-8">
  <img
    src={mcrScreenprintFinal}
    className="w-full sm:w-1/2 max-w-[600px] h-[600px] object-cover rounded shadow-md cursor-pointer"
    onClick={() => handleImageClick(mcrScreenprintFinal, 0)}
    alt="panic stickers for when we were young"
  />
  <img
    src={mcrScreenprintFinal2}
    className="w-full sm:w-1/2 max-w-[600px] h-[600px] object-cover rounded shadow-md cursor-pointer"
    onClick={() => handleImageClick(mcrScreenprintFinal2, 0)}
    alt="panic selfie for when we were young in the shirt"
  />
</div>

<p className="mb-3 text-left text-gray-600 mb-10 mt-0 mx-2 sm:mx-4 md:mx-8 lg:mx-28 xl:mx-56 2xl:mx-72">
This piece was created using a CMYK process screenprint, allowing for full-color reproduction with 
precise layering of cyan, magenta, yellow, and black inks. The technique captures intricate details, 
gradients, and subtle color variations, bringing the My Chemical Romance design to life with a vibrant, 
dynamic finish that stays true to the original concept art. Some were colored in slightly with colored pencils
after the fact, too.
</p>


<h2 className="text-2xl sm:text-3xl md:text-2xl sm:ml-8 md:ml-12 lg:ml-24 xl:ml-32 2xl:ml-72 font-bold text-gray-800 mb-4 mt-8 text-left">
       Screenprinting process </h2>


<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 place-items-center px-4 sm:px-8 md:px-12 lg:px-24 xl:px-32 2xl:px-72 mt-7">

<img
  src={mcrScreenProcess1}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrScreenProcess1, 0)}
  alt="my chemical romance screenprint process"
/>
<img
  src={mcrScreenProcess2}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrScreenProcess2, 0)}
  alt="black parade stickers"
/>


<img
  src={mcrScreenProcess3}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(mcrScreenProcess3, 0)}
  alt="mcr black parade sticker mockup on bag"
/>

</div>


<p className="mb-3 text-left text-gray-600 mb-10 mt-0 mx-2 sm:mx-4 md:mx-8 lg:mx-28 xl:mx-56 2xl:mx-72 mt-2">

The screenprint comes to life in layers: the blue lays down a cool, solid base, adding 
structure and tone; the addition of magenta brings warmth and depth, enhancing the composition; 
finally, combining blue, yellow, and magenta creates the full spectrum, making the colors pop and 
giving the piece vibrant, dynamic energy.
</p>





     
      </div>

      {/* Full-screen image modal */}
      {fullScreenImage && (
        <FullScreenImage
          src={fullScreenImage}
          onClose={handleCloseFullScreen}
          onPrev={handlePrevImage}
          onNext={handleNextImage}
        />
      )}
    </div>
  );
};

export default MCRBlackParade;
